import { c as _c } from "react/compiler-runtime";
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import type { AISummaryReq, AISummaryRes, AskAIReq, GenerateTopicDescriptionReq, GenerateTopicDescriptionRes, HTTPValidationError, TranslationReq } from '../model';
import { customFetch } from '../../fetcher';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];
export const getTranslateInteractionUrl = () => {
  return `/api/v1/openai/translate-interaction`;
};

/**
 * @summary Translate Interaction
 */
export const translateInteraction = async (translationReq: TranslationReq, options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<unknown>(getTranslateInteractionUrl(), {
    ...options,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(translationReq)
  });
};
export const getTranslateInteractionMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof translateInteraction>>, TError, TranslateInteractionMutationVariables, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof translateInteraction>>, TError, TranslateInteractionMutationVariables, TContext> => {
  const mutationKey = ['translateInteraction'];
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof translateInteraction>>, TranslateInteractionMutationVariables> = props => {
    const {
      data
    } = props ?? {};
    return translateInteraction(data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type TranslateInteractionMutationResult = NonNullable<Awaited<ReturnType<typeof translateInteraction>>>;
export type TranslateInteractionMutationBody = TranslationReq;
export type TranslateInteractionMutationError = HTTPValidationError;
export type TranslateInteractionMutationVariables = {
  data: TranslationReq;
};

/**
 * @summary Translate Interaction
 */
export const useTranslateInteraction = options => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getTranslateInteractionMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
export const getSummarizeAIUrl = () => {
  return `/api/v1/openai/summarize-ai`;
};

/**
 * @summary Get Ai Summary
 */
export const summarizeAI = async (aISummaryReq: AISummaryReq, options?: Parameters<typeof customFetch>[1]): Promise<AISummaryRes> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AISummaryRes>(getSummarizeAIUrl(), {
    ...options,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(aISummaryReq)
  });
};
export const getSummarizeAIMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof summarizeAI>>, TError, SummarizeAIMutationVariables, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof summarizeAI>>, TError, SummarizeAIMutationVariables, TContext> => {
  const mutationKey = ['summarizeAI'];
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof summarizeAI>>, SummarizeAIMutationVariables> = props => {
    const {
      data
    } = props ?? {};
    return summarizeAI(data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type SummarizeAIMutationResult = NonNullable<Awaited<ReturnType<typeof summarizeAI>>>;
export type SummarizeAIMutationBody = AISummaryReq;
export type SummarizeAIMutationError = HTTPValidationError;
export type SummarizeAIMutationVariables = {
  data: AISummaryReq;
};

/**
 * @summary Get Ai Summary
 */
export const useSummarizeAI = options => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getSummarizeAIMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
export const getGenerateTopicDescriptionUrl = () => {
  return `/api/v1/openai/generate-topic-description`;
};

/**
 * @summary Generate Topic Description
 */
export const generateTopicDescription = async (generateTopicDescriptionReq: GenerateTopicDescriptionReq, options?: Parameters<typeof customFetch>[1]): Promise<GenerateTopicDescriptionRes> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GenerateTopicDescriptionRes>(getGenerateTopicDescriptionUrl(), {
    ...options,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(generateTopicDescriptionReq)
  });
};
export const getGenerateTopicDescriptionMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof generateTopicDescription>>, TError, GenerateTopicDescriptionMutationVariables, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof generateTopicDescription>>, TError, GenerateTopicDescriptionMutationVariables, TContext> => {
  const mutationKey = ['generateTopicDescription'];
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateTopicDescription>>, GenerateTopicDescriptionMutationVariables> = props => {
    const {
      data
    } = props ?? {};
    return generateTopicDescription(data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type GenerateTopicDescriptionMutationResult = NonNullable<Awaited<ReturnType<typeof generateTopicDescription>>>;
export type GenerateTopicDescriptionMutationBody = GenerateTopicDescriptionReq;
export type GenerateTopicDescriptionMutationError = HTTPValidationError;
export type GenerateTopicDescriptionMutationVariables = {
  data: GenerateTopicDescriptionReq;
};

/**
 * @summary Generate Topic Description
 */
export const useGenerateTopicDescription = options => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getGenerateTopicDescriptionMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
export const getAskAIUrl = () => {
  return `/api/v1/openai/ask-ai`;
};

/**
 * @summary Ask Ai
 */
export const askAI = async (askAIReq: AskAIReq, options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<unknown>(getAskAIUrl(), {
    ...options,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(askAIReq)
  });
};
export const getAskAIMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof askAI>>, TError, AskAIMutationVariables, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof askAI>>, TError, AskAIMutationVariables, TContext> => {
  const mutationKey = ['askAI'];
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof askAI>>, AskAIMutationVariables> = props => {
    const {
      data
    } = props ?? {};
    return askAI(data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type AskAIMutationResult = NonNullable<Awaited<ReturnType<typeof askAI>>>;
export type AskAIMutationBody = AskAIReq;
export type AskAIMutationError = HTTPValidationError;
export type AskAIMutationVariables = {
  data: AskAIReq;
};

/**
 * @summary Ask Ai
 */
export const useAskAI = options => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getAskAIMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};